<!-- 
Dialog for running overdue scheduled jobs.
-->
<template>
<!-- eslint-disable-next-line vue/no-mutating-props -->
  <v-dialog v-model="show" persistent content-class="dialog xs">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Run overdue jobs</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>
        Are you sure you want to run all overdue scheduled jobs?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" flat color="success" @click="run">
          Run
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/scheduled-jobs/action-types";
import * as mutation from "@/store/scheduled-jobs/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state() {
      return this.$store.state.scheduledJobs.runOverdue;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.$store.commit(mutation.RUN_OVERDUE_INITIALISE);
      }
    }
  },
  methods: {
    async run() {
      await this.$store.dispatch(action.RUN_OVERDUE);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
